<template>
  <b-modal
    id="document-model-modal"
    :title="title"
    size="xl"
    hide-footer
    scrollable
  >
    <LmFormBuilder
      class="px-0"
      :endpointUriwhereGetComponents="formbuilderPath"
      :endpointUriWhereGetValuesToLoadInEditMode="dataPathOnEditMode"
      isDisabled
    />
  </b-modal>
</template>

<script>
// Components
import LmFormBuilder from '@/components/LmFormBuilder'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    formbuilderPath: {
      type: String,
      required: true
    },
    dataPathOnEditMode: {
      type: String,
      required: true
    }
  },
  components: {
    LmFormBuilder
  },
  methods: {
    async onPreview () {
      try {
        await this.$bvModal.show('document-model-modal')
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
